import { useState } from "react";
import { controlToastState, Modal, TextInput } from "risa-oasis-ui_v2";
import { narRpaTrigger } from "../../../api/postCall/narRpaTrigger";
import { updatePrimaryDiagnosisCode } from "../../../api/postCall/updatePrimaryDiagnosisCode";
import { ModalId } from "../../../enums/modalId";
import { logError } from "../../../utils/customLogger";

interface NarRpaTriggerModalProps {
  onClose: () => void;
  metaData: { orderId: string };
}
const NarRpaTriggerModal = (props: NarRpaTriggerModalProps) => {
  const [dxCode, setDxCode] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const triggerRPA = async () => {
    if (!dxCode.trim()) {
      controlToastState("dx-code-error");
      return;
    }

    try {
      setIsLoading(true);
      await updatePrimaryDiagnosisCode(props.metaData.orderId, dxCode.trim());
      await Promise.race([
        narRpaTrigger({
          identifier: props.metaData.orderId ?? "",
        }),
        new Promise((resolve) =>
          setTimeout(() => resolve({ success: true }), 2000),
        ),
      ]);
      controlToastState("nar-rpa-trigger-success");
      props.onClose();
    } catch (error) {
      logError(error as Error);
      if (
        error instanceof Error &&
        error.message.includes("primary diagnosis")
      ) {
        controlToastState(
          "Failed to update primary diagnosis code. Please try again.",
        );
      } else {
        controlToastState("nar-rpa-trigger-error");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.NAR_RPA_TRIGGER_MODAL}
      title="Valid Dx Code"
      onSave={triggerRPA}
      onClose={props.onClose}
      saveButtonText={isLoading ? "Updating..." : "Trigger RPA"}
      cancelText="Cancel"
      disableSave={isLoading || !dxCode.trim()}
    >
      <div className="pb-4">
        <TextInput
          id="nar-rpa-trigger-modal-input"
          label="Enter the Dx Code"
          defaultValue={dxCode}
          onChange={(data) => {
            setDxCode(data.value);
          }}
          readOnly={isLoading}
        />
      </div>
    </Modal>
  );
};

export default NarRpaTriggerModal;
